<template>
  <generic-list :apiUrls="apiUrls" :formCols="formCols" :updateCols="updateCols" :tableCols="tableCols"></generic-list>
</template>

<script>
import genericList from '@/views/commonPage/genericList.vue'
import URL from '@/views/business/util/url'
let isDelete = { "1": "启用", "2": "禁用" };
let platform = { "Android": "Android", "IOS": "IOS" };
export default {
  name: "appVersion",
  components: {
    genericList
  },
  data() {
    return {
      apiUrls: {
        query: URL.appVersion.query,
        addOrUpdate: URL.appVersion.addOrUpdate,
        deleteBatchIds: URL.appVersion.deleteBatchIds,
        status: URL.appVersion.status,
        copy: URL.appVersion.copy
      },
      formCols: [

        { title: 'APP名称', field: 'appName' },
        { title: '渠道编号', field: 'utmSource' },
        { title: '版本号', field: 'version' },
        { title: '系统类型', field: 'platform', type: 2, optionList: platform },
        {
          title: '创建时间',
          field: 'time1',
          type: 6,
          format: 'yyyy-MM-dd HH:mm:ss',
          startEndParam: ['createDateBegin', 'createDateEnd']
        },
        { title: '状态', field: 'isDelete', type: 2, optionList: isDelete },

        { click: window.$t('business.bt.search') },
        { click: window.$t('business.bt.add') }
      ],
      updateCols: [
        { title: 'ID', field: 'id', hidden: true },
        {
          title: 'APP名称', field: 'appName', required: true, readonly: (updateModel, col) => {
            // 如果 id 有值，设置为只读；否则不设置
            return !!updateModel.id;
          }
        },
        {
          title: '渠道编号', field: 'utmSource', required: true, readonly: (updateModel, col) => {
            // 如果 id 有值，设置为只读；否则不设置
            return !!updateModel.id;
          }
        },
        {
          title: '系统类型', field: 'platform', type: 2, optionList: platform, required: true, readonly: (updateModel, col) => {
            // 如果 id 有值，设置为只读；否则不设置
            return !!updateModel.id;
          }
        },
        { title: '版本号', field: 'version', required: true },
        { title: '升级版本', field: 'url', upload: true, action: URL.detailTask.uploadUrl, required: true, accept: ".apk",hidePreview: true },
        { title: '状态', field: 'isDelete', required: true, isNumber: true, type: 2, optionList: isDelete },
        { title: '版本描述', field: 'remark', type: 6, uploadUrl: URL.detailTask.uploadUrl },
      ],
      tableCols: [
        { title: 'APP名称', field: 'appName' },
        { title: '渠道编号', field: 'utmSource', h5Click: 'detail' },
        { title: '版本号', field: 'version' },
        {
          title: '系统类型', field: 'platform', render: (data, full) => {
            return platform[data];
          }
        },

        { title: '创建人', field: 'createUser' },
        { title: '更新人', field: 'updateUser' },

        { title: '创建时间', field: 'createDate' },
        { title: '最后修改时间', field: 'updateDate' },
        {
          field: "isDelete", notice: function (value, row) {
            return (value === '1' || value === 1) ? '启用' : '禁用';
          }, title: "启用/禁用开关", size: "mini", click: "status", stype: '100', activeText: "启用", inactiveText: "禁用", hidden: "true"
        },
        {
          title: "升级版本", minWidth: "180", btnClick: [
            { name: window.$t("business.bt.copy"), click: "copy", type: "primary", size: "mini", icon: "el-icon-edit" },
            { name: window.$t("business.bt.down"), click: "download", type: "primary", size: "mini", icon: "el-icon-delete" },
            { name: window.$t("business.bt.edit"), click: "update", type: "primary", size: "mini", icon: "el-icon-edit" },
            {
              name: window.$t("business.bt.delete"), click: "delete", type: "primary", size: "mini", icon: "el-icon-delete"
            }

          ]
        },
      ]
    };
  }
}
</script>